import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { TOKEN_CREATED } from "../../../constants/tokens";
import { getBlocks } from "../../../containers/Blocks/Blocks.actions";
import { BlocksList } from "../../lists";
import { Card } from "antd";
import { RobotOutlined } from "@ant-design/icons";
import "./Blocks.scss";

export default function Blocks({ defaultMaxResults, defaultQuerySize }) {
  const { status, data, error } = useSelector((state: any) => state.Blocks);
  const dispatch = useDispatch();

  const [dateRange] = useState([moment(TOKEN_CREATED), moment()]);

  const [maxResults] = useState(defaultMaxResults);
  const [querySize] = useState(defaultQuerySize);

  useEffect(() => {
    getBlocks(dispatch, dateRange, querySize, maxResults, true);
  }, [dispatch, dateRange, querySize, maxResults]);

  useEffect(
    () => () => getBlocks(dispatch, dateRange, querySize, maxResults, false),
    [dateRange, dispatch, maxResults, querySize]
  );

  return (
    <Card
      title={
        <div className="Blocks__title">
          <div className="Blocks__title__text">
            <RobotOutlined
              style={{ fontSize: 27, verticalAlign: -8, marginRight: 6 }}
            />
            Blocks
          </div>
        </div>
      }
      bodyStyle={{ height: 600, overflow: "auto" }}
    >
      <BlocksList status={status} data={data} error={error} />
    </Card>
  );
}
